function initSwiper() {
  if (typeof Swiper === 'undefined') {
    console.warn('[ec-slider-cards] Swiper lib ainda nao carregou, tentando de novo...');
    setTimeout(initSwiper, 100);
    return;
  }

  document.querySelectorAll('.my-swiper').forEach((el) => {
    if (el.classList.contains('swiper-initialized')) return;

    const slideCount = el.querySelectorAll('.swiper-slide').length;
    const section = el.closest('.ec-slider-cards-section');
    if (slideCount < 3 && section) section.dataset.slideCount = slideCount;

    const paginationEl = el.closest('.ec-swiper-wrapper').querySelector('.swiper-pagination');

    const swiper = new Swiper(el, {
      loop: el.dataset.loop === 'true' && slideCount > 3,
      spaceBetween: parseInt(el.dataset.spaceBetween, 10) || 19,
      slidesPerView: 1,
      observer: true,
      observeParents: true,
      breakpoints: {
        600: { slidesPerView: Math.min(slideCount, 2) },
        900: { slidesPerView: Math.min(slideCount, 3) }
      },
      navigation: {
        nextEl: el.parentElement.querySelector('.swiper-button-next'),
        prevEl: el.parentElement.querySelector('.swiper-button-prev')
      },
      autoplay: el.dataset.autoplay === 'true' ? { delay: 4000 } : false
    });

    if (paginationEl) {
      const maxBullets = 4;
      const totalBullets = Math.min(slideCount, maxBullets);

      paginationEl.innerHTML = '';
      const bullets = [];

      for (let i = 0; i < totalBullets; i++) {
        const bullet = document.createElement('span');
        bullet.className = 'swiper-pagination-bullet' + (i === 0 ? ' swiper-pagination-bullet-active' : '');
        bullet.style.cursor = 'pointer';
        paginationEl.appendChild(bullet);
        bullets.push(bullet);

        bullet.addEventListener('click', () => {
          const currentRealIndex = swiper.realIndex;
          let targetIndex = i;
          let minDiff = Infinity;
          for (let s = 0; s < slideCount; s++) {
            if (s % totalBullets === i) {
              const diff = Math.abs(s - currentRealIndex);
              if (diff < minDiff) {
                minDiff = diff;
                targetIndex = s;
              }
            }
          }
          swiper.slideToLoop(targetIndex);
        });
      }

      swiper.on('slideChange', () => {
        const realIndex = swiper.realIndex;
        const activeBulletIndex = realIndex % totalBullets;

        bullets.forEach((b, idx) => {
          if (idx === activeBulletIndex) {
            b.classList.add('swiper-pagination-bullet-active');
          } else {
            b.classList.remove('swiper-pagination-bullet-active');
          }
        });
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', initSwiper);
document.addEventListener('shopify:section:load', initSwiper);
